"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var getFiltersFromLocation_1 = __importDefault(require("./getFiltersFromLocation"));
function getAppliedFilters() {
    var appliedSearchVariables = lodash_1.pick(getFiltersFromLocation_1.default(), [
        'dateFrom',
        'dateTo',
        'search',
        'sportIds',
        'tournamentIds',
        'matchStatuses',
        'freeBetId',
        'sportId',
        'tournamentId',
        'hasStreams',
    ]);
    Object.keys(appliedSearchVariables).forEach(function (key) {
        if (typeof appliedSearchVariables[key] !== 'string')
            return;
        appliedSearchVariables[key] = booleanizeSearchStringValue(appliedSearchVariables[key]);
    });
    return appliedSearchVariables;
}
exports.default = getAppliedFilters;
function booleanizeSearchStringValue(search) {
    return search.match(/^false$/g)
        ? false
        : !!search.match(/^true$/g) || search;
}
//# sourceMappingURL=getAppliedFilters.js.map